import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '@/plugins/feathersClient'

class TimeTracker extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'TimeTracker'

  // Define default properties here
  static instanceDefaults() {
    return {
      startTime: new Date(),
      endTime: new Date(),
      purpose: '',
      groupName: '',
      groupLevel: ''
    }
  }
}
const servicePath = 'time-tracker'
const servicePlugin = makeServicePlugin({
  Model: TimeTracker,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
